import React from 'react';
import { MenuWidget } from './components/MenuWidget';
import { usePrepareConfiguration } from './hooks/usePrepareConfiguration.hook';
import useGetCompanyParams from './hooks/useGetCompanyParams.hook';
import useGetCompanyDietsDetails from './hooks/useGetCompanyDietsDetails.hook';

function App({ config }) {
  const { initDietId, showSelect, companyId, height, path } =
    usePrepareConfiguration(config);
  const { companyParams } = useGetCompanyParams(companyId);
  const { companyDietDetails } = useGetCompanyDietsDetails(companyId);

  return (
    <div
      className="dietly-app"
      style={{
        height,
      }}
    >
      {companyId && companyParams && companyDietDetails && (
        <div className={'dietly-app-1 dietly-app-2 dietly-app-3 dietly-app-4'}>
          <MenuWidget
            companyDietDetails={companyDietDetails}
            companyId={companyId}
            companyParams={companyParams}
            initDietId={initDietId}
            path={path}
            showSelect={showSelect}
          />
        </div>
      )}
    </div>
  );
}

export default App;
